export const combineRegexp = (...regexps: Array<RegExp>) => new RegExp(regexps
  .map((regex) => `(${regex.source})`).join('|'));

export const firstSlashRegExp = '^\\/';
export const getParametersRegExp = '\\?.*';
export const slugRegExp = '^\\/[\\w\\-\\/]+';
export const commonEmailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const commonPhoneRegexp = /^[0-9]{7,12}$/g;
export const fileExtension = /\.+.[a-zA-Z]/g;
